import { useEffect, useMemo } from 'react'
import { setPageTitle } from '../framework/title'

/**
 * Sets the document title and joins with a | character.
 *
 * Note: It does not put the title back on unmount, so your title may not be correct
 * if you try to nest calls to useTitle and then remove them.
 */
export function useTitle(title: string | string[]): void {
  const titleString = useMemo(() => {
    const titleArray = Array.isArray(title) ? title : [title]
    const titlesFiltered = titleArray.filter(Boolean).join(' | ').trim()
    return titlesFiltered
  }, [title])

  useEffect(() => {
    setPageTitle(titleString)
  }, [titleString])
}
